(function () {
  'use strict';

  // Variants and option positions are injected by Liquid into window.__atomsProduct
  const productData = window.__atomsProduct;
  if (!productData) return;

  const variants = productData.variants;
  const optionPositions = productData.optionPositions; // { Color: 0, US: 1, Size: 2 }

  const US_IDX = optionPositions['US'];
  const SIZE_IDX = optionPositions['Size'];

  // --- Helper: find a hidden native radio input by option name + value ---
  function findNativeInput(optionName, value) {
    return document.querySelector(
      `input[name="options[${optionName}]"][value="${CSS.escape(value)}"]`
    );
  }

  // --- Helper: click a native radio to trigger Dawn's variant-selects ---
  function selectNativeOption(optionName, value) {
    const input = findNativeInput(optionName, value);
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (input && input.checked) {
      // Already selected — still fire change so our UI stays in sync
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // --- Helper: get option value from a variant by index ---
  function getOptionValue(variant, idx) {
    return variant['option' + (idx + 1)];
  }

  // --- Helper: check if a size is available for a given US value ---
  function isSizeAvailable(sizeValue, usValue) {
    return variants.some(function (v) {
      const matchesSize = SIZE_IDX !== undefined ? getOptionValue(v, SIZE_IDX) === sizeValue : true;
      const matchesUS = US_IDX !== undefined ? getOptionValue(v, US_IDX) === usValue : true;
      return matchesSize && matchesUS && v.available;
    });
  }

  // --- Helper: format money (cents → $X.XX or $X) ---
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, '${{amount}}');
    }
    const dollars = cents / 100;
    if (dollars % 1 === 0) return '$' + dollars;
    return '$' + dollars.toFixed(2);
  }

  // --- Update the CTA button label ---
  function updateButtonLabel(variant, sizeSelected) {
    const btn = document.querySelector('[data-atoms-btn]');
    if (!btn) return;
    const labelSpan = btn.querySelector('.atoms-btn-label');
    if (!labelSpan) return;

    if (!variant || !sizeSelected) {
      const basePrice = variants.length > 0 ? variants[0].price : 0;
      const price = variant ? variant.price : basePrice;
      labelSpan.textContent = 'Select Size \u00B7 ' + formatMoney(price);
    } else {
      labelSpan.textContent = 'Add to Cart \u00B7 ' + formatMoney(variant.price);
    }
  }

  // --- Re-evaluate OOS states on size pills after US tab change ---
  function refreshSizePillAvailability(usValue) {
    const pills = document.querySelectorAll('.atoms-size-pill');
    pills.forEach(function (pill) {
      const sizeValue = pill.dataset.value;
      const available = isSizeAvailable(sizeValue, usValue);
      if (available) {
        pill.classList.remove('is-oos');
        pill.removeAttribute('aria-label');
      } else {
        pill.classList.add('is-oos');
        pill.setAttribute('aria-label', 'Size ' + sizeValue + ' \u2014 notify me when available');
      }
    });
  }

  // --- Track selected state ---
  let selectedSize = null;

  // --- COLOR PICKER ---
  const colorPicker = document.querySelector('[data-atoms-color-picker]');
  if (colorPicker) {
    colorPicker.addEventListener('click', function (e) {
      const thumb = e.target.closest('.atoms-color-thumb');
      if (!thumb) return;

      const value = thumb.dataset.value;

      // Update UI
      colorPicker.querySelectorAll('.atoms-color-thumb').forEach(function (t) {
        t.classList.toggle('is-selected', t.dataset.value === value);
        t.setAttribute('aria-pressed', t.dataset.value === value ? 'true' : 'false');
      });

      // Update color name label
      const nameEl = colorPicker.querySelector('[data-color-name]');
      if (nameEl) nameEl.textContent = value;

      // Update native input
      selectNativeOption('Color', value);
    });
  }

  // --- SIZE PICKER ---
  const sizePicker = document.querySelector('[data-atoms-size-picker]');
  if (sizePicker) {

    // US tab selection
    sizePicker.addEventListener('click', function (e) {
      const tab = e.target.closest('.atoms-us-tab');
      if (!tab) return;

      const value = tab.dataset.value;

      // Update UI
      sizePicker.querySelectorAll('.atoms-us-tab').forEach(function (t) {
        t.classList.toggle('is-selected', t.dataset.value === value);
      });

      // Clear size selection when switching gender
      selectedSize = null;
      sizePicker.querySelectorAll('.atoms-size-pill').forEach(function (p) {
        p.classList.remove('is-selected');
      });

      // Re-evaluate OOS states for the new US value
      refreshSizePillAvailability(value);

      // Update native input
      selectNativeOption('US', value);

      // Update button label (no size selected after tab switch)
      updateButtonLabel(null, false);
    });

    // Size pill selection
    sizePicker.addEventListener('click', function (e) {
      const pill = e.target.closest('.atoms-size-pill');
      if (!pill || pill.classList.contains('is-oos')) return;

      const value = pill.dataset.value;
      selectedSize = value;

      // Update UI
      sizePicker.querySelectorAll('.atoms-size-pill').forEach(function (p) {
        p.classList.toggle('is-selected', p.dataset.value === value);
      });

      // Update native input
      selectNativeOption('Size', value);
    });

    // See all sizes toggle
    const seeAllBtn = sizePicker.querySelector('[data-see-all]');
    const sizeGrid = sizePicker.querySelector('.atoms-size-grid');
    if (seeAllBtn && sizeGrid) {
      seeAllBtn.addEventListener('click', function () {
        sizeGrid.classList.add('atoms-size-grid--expanded');
        seeAllBtn.style.display = 'none';
      });
    }
  }

  // --- Listen for variant:change from Dawn's variant-selects ---
  document.addEventListener('variant:change', function (e) {
    const variant = e.detail && e.detail.variant;
    updateButtonLabel(variant, !!selectedSize);
  });

  // --- Initialize defaults on page load ---
  (function initDefaults() {
    // Default US tab: Men's
    var defaultUS = "Men's";
    var usTab = sizePicker && sizePicker.querySelector('.atoms-us-tab[data-value="' + defaultUS + '"]');
    if (usTab && !usTab.classList.contains('is-selected')) {
      sizePicker.querySelectorAll('.atoms-us-tab').forEach(function (t) {
        t.classList.toggle('is-selected', t.dataset.value === defaultUS);
      });
      selectNativeOption('US', defaultUS);
      refreshSizePillAvailability(defaultUS);
    }

    // Default size: 8
    var defaultSize = '8';
    var sizePill = sizePicker && sizePicker.querySelector('.atoms-size-pill[data-value="' + defaultSize + '"]');
    if (sizePill && !sizePill.classList.contains('is-oos')) {
      sizePicker.querySelectorAll('.atoms-size-pill').forEach(function (p) {
        p.classList.toggle('is-selected', p.dataset.value === defaultSize);
      });
      selectedSize = defaultSize;
      selectNativeOption('Size', defaultSize);
    }

    // Read initial variant and update button label
    var variantScript = document.querySelector('[data-selected-variant]');
    var initialVariant = null;
    if (variantScript) {
      try {
        initialVariant = JSON.parse(variantScript.textContent);
      } catch (err) {
        // ignore
      }
    }
    updateButtonLabel(initialVariant, !!selectedSize);
  })();

})();
